module.exports = __webpack_public_path__ + "33cf49dfd31be94d5a3c7ba21f7ad9d1.MP3";